import en from "./en/index";
import ja from "./ja/index";

export default {
  en: en,
  ja: ja,
};
